module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/edit-1c81c0eef71df4cd4c695631ad264589.svg";